import React from 'react';

interface ChatInputProps {
    input: string;
    setInput: (input: string) => void;
    sendMessage: () => void;
    isSending: boolean;
}

const ChatInput: React.FC<ChatInputProps> = ({ input, setInput, sendMessage, isSending }) => {
    return (
        <div className="flex-none items-center pt-0">
            <form className="flex items-center justify-center w-full space-x-2" onSubmit={(e) => { e.preventDefault(); sendMessage(); }}>
                <input
                    className="flex h-10 w-full rounded-md border border-[#e5e7eb] px-3 py-2 text-sm placeholder-[#6b7280] focus:outline-none focus:ring-2 focus:ring-[#9ca3af] disabled:cursor-not-allowed disabled:opacity-50 text-[#030712] focus-visible:ring-offset-2"
                    placeholder="Deine Anfrage"
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    onKeyDown={(e) => e.key === 'Enter' && sendMessage()}
                    disabled={isSending}
                />
                <button
                    type="submit"
                    className="inline-flex items-center justify-center rounded-md text-sm font-medium text-white disabled:pointer-events-none disabled:opacity-50 bg-[#a3ca63] hover:bg-opacity-80 transition-colors duration-200 h-10 px-4 py-2"
                    disabled={isSending}
                >
                    Senden
                </button>
            </form>
        </div>
    );
};

export default ChatInput;